export default class WpaCodeParameterInjector {

    /**
     * WpaCodeParameterInjector constructor.
     *
     * @param {WpaCode} wpacode
     */
    constructor(wpacode) {
        this.wpacode = wpacode;
    }

    /**
     * Find links and inject the wpacode parameter
     */
    findLinksAndInject() {
        const links = document.querySelectorAll('a');

        for (let link of links) {
            let href = link.getAttribute('href');

            if (href != null && href !== '#') {
                href = this.wpacode.appendToUrl(href);
                link.setAttribute('href', href);
            }
        }
    }

}